export default __webpack_public_path__ + "static/media/video1.5e223a6d.jpg";